import * as React from 'react'
import {useRef} from 'react'
import {useFormContext} from 'react-hook-form'
import {useTranslation} from 'react-i18next'
import * as yup from 'yup'
import {useBoldInputStyle} from 'components/common/useBoldInputStyle'

export default function PasswordInput() {
  const createMemberInfo = useFormContext()
  const classes = useBoldInputStyle()
  const {t} = useTranslation()

  const schema = yup.object({
    password: yup
      .string()
      .required(t('IRequired'))
      .min(8, t('IPasswordLength'))
      .max(20, t('IPasswordLength')),
  })

  const {
    watch,
    formState: {errors},
  } = useFormContext()
  const password = useRef({})
  password.current = watch('password', '')

  return (
    <div className={classes.root}>
      <div className={classes.labelWrapContainer}>
        <p className={classes.inputLabel}>{t('IPasswordFirstLogin')}</p>
        <p className={classes.require}>*</p>
      </div>
      <div className={classes.inputContainer}>
        <div className={classes.inputWrap}>
          <input
            id='password'
            placeholder={t('IRegisterPassword')}
            className={classes.input}
            style={{maxHeight: 50}}
            type='password'
            autoComplete='new-password'
            {...createMemberInfo.register('password', {
              validate: (password) =>
                schema.validate({password}).catch((e) => e.errors[0]),
            })}
          />
          {errors.password && (
            <span className={classes.errorText} style={{maxWidth: 300}}>
              {errors.password && errors.password.message}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
